import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import Products from 'merchandise-lib/constants/Product';
import { DataHubFaqs } from 'pricing-pages-ui-components/frequentlyAskedQuestions/DataHubFaqs';
import { DataHubProductIcon } from 'pricing-pages-ui-components/productIcon/DataHubProductIcons';
import { PageSubTitle, PageTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { CreditsCallout } from '../../../components/common/credits-callout/CreditsCallout';
import CalculatorAnchorLink from '../../../components/common/CalculatorAnchorLink';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';
import PhoneSupportFooter from '../../components/phone-support/PhoneSupportFooter';
import PhoneSupportMiddle from '../../components/phone-support/PhoneSupportMiddle';
import { SCREENS } from '../../constants/tracking/Screens';
import { BannerSection } from '../../containers/BannerSection';
import { IntegrationsSection } from '../../containers/IntegrationsSection';
import { trackPageView } from '../../utils/tracking/trackingEventUtils';
import { DataHubFeatureTable } from './DataHubFeatureTable';
import { DataHubMerchCards } from './DataHubMerchCards';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OPERATIONS_HUB_API_NAMES = [Products.OPERATIONS_HUB_STARTER, Products.OPERATIONS_HUB_PROFESSIONAL, Products.OPERATIONS_HUB_ENTERPRISE];
export const DataHubPage = () => {
  const screen = SCREENS.DATA;
  useDocumentTitle(screen);
  useEffect(() => {
    trackPageView({
      screen
    });
  }, [screen]);
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "DATA_PAGE_V2",
    children: [/*#__PURE__*/_jsx(BannerSection, {
      screen: "DATA",
      apiNames: OPERATIONS_HUB_API_NAMES
    }), /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsxs(PageTitle, {
        "aria-level": 1,
        children: [/*#__PURE__*/_jsx(DataHubProductIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.data.pageTitle"
        })]
      }), /*#__PURE__*/_jsxs(PageSubTitle, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.data.description"
        }), /*#__PURE__*/_jsx(CalculatorAnchorLink, {
          defaultProductApiName: Products.OPERATIONS_HUB_PROFESSIONAL
        })]
      })]
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(DataHubMerchCards, {})
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(CreditsCallout, {
        navItem: "data"
      })
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(DataHubFeatureTable, {})
    }), /*#__PURE__*/_jsx(PhoneSupportMiddle, {
      phoneSourceId: "operations-middle",
      screen: screen,
      apiName: Products.OPERATIONS_HUB_STARTER
    }), /*#__PURE__*/_jsx(IntegrationsSection, {
      nav: "data"
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(DataHubFaqs, {})
    }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
      phoneSourceId: "operations-footer",
      screen: screen,
      apiName: Products.OPERATIONS_HUB_STARTER
    })]
  });
};